import DeleteMeetingForwardNotificationOption from './DeleteMeetingForwardNotificationOption';
import DeleteOldMeetingMessageOption from './DeleteOldMeetingMessageOption';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
/**
 * Stateless functional component to render invitation options in settings.
 */
export default observer(function InvitationFull() {
    return (React.createElement("div", null,
        React.createElement(OptionDescription, null, strings.options_invitation_description),
        React.createElement(DeleteOldMeetingMessageOption, null),
        React.createElement(DeleteMeetingForwardNotificationOption, null)));
});
//# sourceMappingURL=InvitationFull.js.map